import { Injectable, inject } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { TypeFilterService } from './court-filter.enums';
import { ENV_TOKEN } from '../../../app-module.token';


@Injectable({
  providedIn: 'root'
})
export class CourtFilterService {
  public constService: any;

  private httpService: HttpService = inject(HttpService);
  readonly environment = inject(ENV_TOKEN);
  constructor() {
    this.constService = this.environment;
  }

  getFiltro(Request: any, TypeFilter: TypeFilterService): any {

    let serviceCall = '';

    switch (TypeFilter) {
      case TypeFilterService.Ambito: serviceCall = 'ObtenerAmbito'; break;
      case TypeFilterService.TipoFiltroClasificacion: serviceCall = 'ObtenerClasificacion'; break;
      case TypeFilterService.CircuitosRegiones: serviceCall = 'ObtenerTipoFiltro'; break;
      case TypeFilterService.EntidadFederativa: serviceCall = 'ObtenerEntidadFederativaXCircuito'; break;
      case TypeFilterService.TipoOrganismo: serviceCall = 'ObtenerCircuitosXTipoOrganismo'; break;
      case TypeFilterService.Materia: serviceCall = 'ObtenerMateriasXTipodeOrganismo'; break;
      case TypeFilterService.Organismo: serviceCall = 'ObtenerOrganismoXTipodeOrganismoXCircuitoLab'; break;
      case TypeFilterService.TipoAsunto: serviceCall = 'ObtenerTipoAsuntoXOrganismoXMateria'; break;
      case TypeFilterService.OCC: serviceCall = 'ObtenerOCCXCircuitoEntidad'; break;
    }
    return this.httpService.postRequestCat(`${this.constService.FilterCourtURL}/${serviceCall}`, Request);
  }


}
